var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "vnp-input-box"
  }, [_c('ul', _vm._l(_vm.val, function (item, index) {
    return _c('li', {
      key: index,
      class: {
        active: _vm.activeIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.handleClickItem(index);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item))])]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };